import React from "react";
import { useEffect } from "react";
import {
  supportPageVideo,
  allbooksFinalVideo,
  orderHistoryVideo,
  instantOrderVideo,
} from "../library/constants";
import call from "../library/svg/call.svg";
import mail from "../library/svg/mail.svg";
import { elsevierStyleSheetJSfileImport } from "../library/utils";

const Queries = (props) => {


  useEffect(() => {
    elsevierStyleSheetJSfileImport();
  }, []);

  return (
    <>
      <h1>FAQ and Videos</h1>
      <div>&nbsp;</div>
      <div className="video_section">
        <label htmlFor="allbooks-video">
          <strong>All Books Video</strong>{" "}
        </label>
        <div>&nbsp;</div>
        <video
          id="allbooks-video"
          src={allbooksFinalVideo}
          className="react-player"
          width="70%"
          height="100%"
          controls
        />
      </div>

      <div className="video_section">
        <label htmlFor="instant_order_video">
          <strong>Instant Order Video</strong>
        </label>
        <div>&nbsp;</div>
        <video
          id="instant_order_video"
          src={instantOrderVideo}
          className="react-player"
          width="70%"
          height="100%"
          controls
        />
      </div>
      <div className="video_section">
        <label htmlFor="order_history_video">
          <strong>Order History Video</strong>
        </label>
        <div>&nbsp;</div>
        <video
          id="order_history_video"
          src={orderHistoryVideo}
          className="react-player"
          width="70%"
          height="100%"
          controls
        />
      </div>
      <div className="video_section">
        <label htmlFor="support_page_video">
          <strong>Support Page Video</strong>
        </label>
        <div>&nbsp;</div>
        <video
          id="support_page_video"
          src={supportPageVideo}
          className="react-player"
          width="70%"
          height="100%"
          controls
        />
      </div>

      <div
        className="es-accordion es-js-accordion"
        data-accordion-multiple=""
        id="demo-2"
      >
        <h4 className="es-accordion-heading">
          <button aria-controls="demo-sciencedirect" aria-expanded="true">
            <span>How do I make a purchase on your site?</span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="demo-sciencedirect">
          <ul className="es-list">
            <li>
              You can visit our site{" "}
              <a href="https://bookart.elsevier.com/">
                https://bookart.elsevier.com/
              </a>{" "}
              using your credentials. After browsing our site, if you find any
              product you wish to purchase, simply click the{" "}
              <strong>‘Add to Cart’ </strong> button.
            </li>
            <li>
              Once you have finished adding all chosen items to your cart,
              click on
              <strong> ‘Cart Icon’ </strong> which is on the top right corner
              of your home screen and then click on{" "}
              <strong>'View Cart' </strong>
              for checkout.
            </li>

            <li>
              The other way you can do this is simply by clicking
              <strong> 'View Cart' </strong> which you will find on the bottom
              right below <strong> ‘Qty’</strong> , the same screen where the
              title details screen is.
            </li>

            <li>
              The checkout process involves below simple steps:
              <ol className="es-list">
                <li>
                  Go to Cart, click on
                  <strong> ‘Confirm Address’ </strong>
                </li>
                <li>
                  Choose your billing and shipping address/es available in the
                  platform.
                </li>
                <li>
                  If you have multiple addresses, simply click on
                  <strong> ‘View All’ </strong>
                  then you will get multiple address for selection.
                </li>
                <li>
                  If you can’t find any of your address/es, then you can{" "}
                  <div
                    className="email_link pointer"
                    onClick={() => {
                      // Change the screen to "mail"
                      props.changeScreen("mail");
                    }}
                  >
                    Contact Us
                  </div>.
                </li>
                <li>
                  Once you confirm the address, click on
                  <strong> ‘Proceed to Checkout’ </strong>.
                </li>
                <li>Review your order before confirming the order.</li>
                <li>
                  Click on <strong> ‘I hereby confirm my order’ </strong>{" "}
                  check box and then proceed by clicking on
                  <strong> ‘Confirm order’ </strong>.
                </li>
                <li>
                  If you wish to shop you can click on
                  <strong> ‘Continue Shopping’ </strong>.
                </li>
              </ol>
            </li>
            <li>
              Once you are done with the order confirmation you will receive
              an order confirmation email along with the order reference
              number to your registered email id
            </li>
            <li>
              If you have any issues or questions about the order process, do
              not hesitate to{" "}
              <div
                className="email_link pointer"
                onClick={() => {
                  // Change the screen to "mail"
                  props.changeScreen("mail");
                }}
              >
                Contact Us
              </div>
            </li>
          </ul>
        </div>

        <h4 className="es-accordion-heading">
          <button aria-controls="demo-scopus" aria-expanded='false'>
            <span>
              How long do I have to wait to receive the books I ordered?
            </span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="demo-scopus">
          <ul className="es-list">
            <li>
              Once you have submitted your order via BooKart platform, we will
              process it within 24 hours and then ship it to your address.
            </li>
            <li>
              Delivery estimate time post dispatched/Shipped:
              <ol className="es-list">
                <li>
                  For inner city delivery, the order will be delivered on the
                  same day. If the order request is received after 12:30PM,
                  then delivery will take place on the next working day.
                </li>
                <li>
                  Generally, outstation or interstate delivery will take 7-10
                  working days to be delivered.
                </li>
              </ol>
            </li>

            <li>
              Three reasons your order might not get dispatch/shipped:
              <ol className="eslist">
                <li>Your order is on credit hold due to low credit limit.</li>
                <li>Your account is hold with legal team.</li>
                <li>Stocks are not available at PAN India level.</li>
              </ol>
            </li>
          </ul>
        </div>

        <h4 className="es-accordion-heading">
          <button aria-controls="demo-mendeley" aria-expanded="false">
            <span>
              How long do I have to wait to receive the order details?
            </span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="demo-mendeley">
          <ul className="es-list">
            <li>
              Once you have submitted your order via BooKart platform, you
              will get an email confirmation along with the reference number.
              In the next 24 Hours, you will also receive an order acknowledgment 
              email from our team with relevant order details.
            </li>
          </ul>
        </div>

        <h4 className="es-accordion-heading">
          <button aria-controls="demo-ssrn" aria-expanded="false">
            <span>How can I change my shipping and/or billing address?</span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="demo-ssrn">
          <ul className="es-list">
            <li>
              Please write an email to{" "}
              <div
                className="email_link pointer"
                onClick={() => {
                  // Change the screen to "mail"
                  props.changeScreen("mail");
                }}
              >
                IndiaHSBooks@elsevier.com
              </div>
              so we can help you assist in changing the shipping and/or
              billing address.
            </li>
            <li>
              Follow the below steps:
              <ol className="es-list">
                <li>Go to your BooKart Home Screen.</li>
                <li>
                  Click on <strong> ‘Support’ </strong> which is on the top
                  right corner, you can reach out to any of the Health Science
                  agent via phone or email.
                </li>
                <li>
                  You can also click on <strong> ‘Email Us’ </strong> which is
                  just below
                  <strong> ‘Contact Us’. </strong>
                </li>
              </ol>
            </li>
            <li>
              While writing to us, please mention the complete
              shipping/billing address along with the official document
              bearing the address.
            </li>
          </ul>
        </div>
        <h4 className="es-accordion-heading">
          <button aria-controls="reset-password" aria-expanded="false">
            <span>How can I reset my Login ID and/or Password ?</span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="reset-password">
          <ul className="">
            <li>
              Your login id will be your registered email address used at the
              time of account activation. To reset your password, click on{" "}
              <strong> {` 'Forgot your password’ `}</strong> . A link will be
              sent to your registered email id, using which you can reset your
              password.
            </li>
          </ul>
        </div>

        <h4 className="es-accordion-heading">
          <button
            aria-controls="order-status-accordian"
            aria-expanded="false"
          >
            <span>Can I know my order status ?</span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="order-status-accordian">
          <ul className="es-list">
            <li>
              Yes, Follow the below steps to know your order status:
              <ol className="es-list">
                <li>Go to your BooKart Home Screen.</li>
                <li>
                  Click on <strong>{` ‘Order History’  `} </strong> on the top
                  right corner, here you can view the status of orders placed 
                  through BooKart, along with other relevant details.
                </li>
                <li>
                  You can use the <strong>{` ‘Order number’ `} </strong> in
                  the search field to know the previous or recent order status
                  placed only via BooKart.
                </li>
                <li>
                  You can use the drop-down list
                  <strong>{` ‘Recent’ `} </strong> on the right corner to
                  filter your search based on the month and year.
                </li>
                <li>
                  You can also click on{" "}
                  <strong>{` ‘Reference number’ `} </strong> to know the title
                  placed against the order.
                </li>
              </ol>
            </li>
          </ul>
        </div>
        <h4 className="es-accordion-heading">
          <button aria-controls="delivery-tracker" aria-expanded="false">
            <span>Can I track my delivery?</span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="delivery-tracker">
          <ul className="es-list">
            <li>
              You will be getting the dispatch details of your orders to your
              registered email id. With the help of the waybill number you can
              track your order.
            </li>
            <li>
              You can also reach us by raising a query via email along with
              the order number using the below steps:
              <ol className="es-list">
                <li> Go to your BooKart Home Screen,</li>
                <li>
                  Click on
                  <strong>{` ‘Support’ `}</strong>
                  which is on the top right corner, you can reach out to any
                  of the Health Science agent via phone or email.
                </li>
                <li>
                  You can also click on <strong>{` ‘Email Us’ `}</strong>{" "}
                  which is just below
                  <strong>{` ‘Contact Us’ `}</strong>
                </li>
              </ol>
            </li>
          </ul>
        </div>
        <h4 className="es-accordion-heading">
          <button aria-controls="wrong-product" aria-expanded="false">
            <span>I received the wrong product. What can I do?</span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="wrong-product">
          <ul className="es-list">
            <li>
              If you receive an item you didn’t order, please reach out to us
              via email or phone so we can rectify the situation as soon as
              possible. You can follow the below step to reach us:
              <ol className="es-list">
                <li>Go to your BooKart Home Screen.</li>
                <li>
                  Click on <strong>{` ‘Support’ `}</strong>
                  which is on the top right corner, you can reach out to any
                  of the Health Science agent via phone or email.
                </li>
                <li>
                  You can also click on <strong>{`‘Email Us’ `}</strong> which
                  is just below <strong>{` ‘Contact Us’ `}</strong>.
                </li>
              </ol>
            </li>
          </ul>
        </div>
        <h4 className="es-accordion-heading">
          <button aria-controls="cancel-product" aria-expanded="false">
            <span>Can I cancel my order?</span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="cancel-product">
          <ul className="es-list">
            <li>
              Please write an email to{" "}
              <div
                className="email_link pointer"
                onClick={() => {
                  // Change the screen to "mail"
                  props.changeScreen("mail");
                }}
              >
                IndiaHSBooks@elsevier.com
              </div>
              or you can raise a query using the below steps:
              <ol className="es-list">
                <li>Go to your BooKart Home Screen.</li>
                <li>
                  Click on <strong>{` ‘Support’ `}</strong>
                  which is on the top right corner, you can reach out to any
                  of the Health Science agent via phone or email.
                </li>
                <li>
                  You can also click on <strong>{`‘Email Us’ `}</strong> which
                  is just below <strong>{` ‘Contact Us’ `}</strong>.
                </li>
              </ol>
            </li>
          </ul>
        </div>
        <h4 className="es-accordion-heading">
          <button aria-controls="place_bulk_order" aria-expanded="false">
            <span>How can I place bulk order? </span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="place_bulk_order">
          <ul className="es-list">
            <li>
              If you want to place a bulk order using the details which you
              already have prepared in either in excel or PDF, you can use the
              below steps
              <ol className="es-list">
                <li>
                  On your Home screen or top of your screen you will find the
                  tab <strong> ‘Instant Order’ </strong> .
                </li>
                <li>
                  Click on the <strong> ‘Instant Order’ </strong>, you will find an email template where you will be able to place your bulk order.
                </li>
                <li>Simply attach your file which has your order details (ISBN, Author, Title and Quantity)</li>
                <li>
                  Please do add the subject of your orders like PO Number etc
                </li>
                <li>Click on the checkbox ‘I hereby confirm my order’ and confirm your order</li>
              </ol>
              Note: You can upload only the excel and PDF file in your order request, no other document is accepted
            </li>
          </ul>
        </div>
        <h4 className="es-accordion-heading">
          <button aria-controls="raise-query" aria-expanded="false">
            <span>How do I raise a query?</span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="raise-query">
          <ul>
            <li>
              You can raise a query using the following below steps:
              <ol>
                <li>Go to your BooKart Home Screen.</li>
                <li>
                  Click on <strong> {` ‘Support’ `}</strong> which is in the
                  top right corner.
                </li>
                <li>
                  Click on <strong> {` ‘Email Us’ `}</strong> which is just
                  below the <strong> {` ‘Contact Us’ `}.</strong>
                </li>
                <li>
                  Select the type of query you want from the drop list
                  available under <strong> {` ‘Query Type’ `}.</strong>
                </li>
                <li>You can also attach your file (PDF/Excel).</li>
                <li>
                  You can enter your additional information under free text
                  field.
                </li>
                <li>
                  Then click on the <strong> {` ‘Submit Query’ `}</strong> .
                </li>
              </ol>
            </li>
          </ul>
        </div>
        <h4 className="es-accordion-heading">
          <button aria-controls="session-management" aria-expanded="false">
            <span>
              How long will the session remain and What happens when a session
              expires?
            </span>
            <svg viewBox="0 0 92 128" height="24" width="18">
              <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
            </svg>
          </button>
        </h4>
        <div id="session-management">
          <ul className="es-list">
            <li>
              If the BooKart is not in use and remains inactive for 1 hour 
              after signing in, the session will automatically expire.
            </li>
            <li>
              Once the session times out, you will be directed to the 
              sign-in page to begin using BooKart again.
            </li>
            <li>
              Sign in again using the same credential to continue using
              BooKart.
            </li>
          </ul>
        </div>
      </div>
      <div className="Queries_email_container">
        <div
          className="queries_mail pointer"
          onClick={() => {
            props.changeScreen("call");
          }}
        >
          <img src={call} alt="call" />
        </div>
        <div
          className="queries_mail pointer"
          onClick={() => {
            props.changeScreen("mail");
          }}
        >
          <img src={mail} alt="mail" />
        </div>
      </div>
    </>
  );
};

export default Queries;